import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GithubDataService {

  constructor(private http: HttpClient) { }

  public getGitHubData(url: string): any {
    return this.http.get(url, { responseType: 'text' });
  }
}
